
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import LogisticsSelect from '../components/select.vue';
	import Message from '@/components/message.vue';
	import CollapseItem from '@/components/collapse.vue';

	import {
		imgHost,
		maxspecifications
	} from '@/utils/config';
  import {
    freightSettlementTemplatefreightSettlementTemplateInfo,
    freightSettlementTemplatefreightSettlementTemplateSave,
  } from "@/api/logistics"
  @Component({  
    name: '',
    components: {
      PageFooter,
			LogisticsSelect,
			'slz-message': Message,
      CollapseItem,
    }
  })

  export default class ProductList extends Vue {
    private shop = {
      Name:decodeURIComponent((this as any).$route.query.Name),
      Img:decodeURIComponent((this as any).$route.query.Img),
    }
		private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private loading = false
    private form:any = {
      Id:this.$route.query.Id||0,
      TemplateName:'',
      FreightSettlementType:1,
      DetailList:[],
      UseProductList:[],
    }
    private modelist:any = []
    private changemsg:any = {}
    private isShowDialog = false
    private selectArea:any = []
    private disableDate:any = []
    private orderSaveTips = false
    private areatype = 1
    private disabled = Boolean(this.$route.query.Type)

    private routuanPrice = ''
    private totalSku:any = []
    private ProductInfo:any = {}
    private skuName = []
    private specificationsNum = maxspecifications
    private shoplist:any = []


    private mounted () {

      if(Number(this.$route.query.Id)||Number(this.$route.query.ProductId)){
        this.getDate()
      }
    }



    private changAllPricd2(e,type,v,i){
      let two = /^\d+(\.\d{1,2})?$/
      let routuanPrice = this.totalSku[i].RouTuanPrice
      if(Number(routuanPrice)<0.01||Number(routuanPrice)>999999.99||!two.test(routuanPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.totalSku[i].RouTuanPrice = ''
        return
      }
      this.ProductInfo.ProductMixList = this.ProductInfo.ProductMixList.map((v,index)=>{
        if(index==i){
          v.ProductSpecList = v.ProductSpecList.map(x=>{
            x.RouTuanPrice = this.totalSku[i].RouTuanPrice
            return x
          })
        }
        return v
      })
    }
    private changAllPricd(e,type,v,i){
      let two = /^\d+(\.\d{1,2})?$/
      let routuanPrice = this.totalSku[i].RouTuanPrice
      if(Number(routuanPrice)<0.01||Number(routuanPrice)>999999.99||!two.test(routuanPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.totalSku[i].RouTuanPrice = ''
        return
      }
      this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map((v,index)=>{
        if(i==index){
          v = v.map(x=>{
            x.RouTuanPrice = this.totalSku[i].RouTuanPrice
            return x
          })
        }
        return v
      })
    }
    private setRoutuanPrice(){
      if(!this.routuanPrice){
        return
      }
      let two = /^\d+(\.\d{1,2})?$/
      let routuanPrice = Number(this.routuanPrice)
      if(routuanPrice<0.01||routuanPrice>999999.99||!two.test(this.routuanPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.routuanPrice = ''
        return
      }
      if(this.ProductInfo.ProductType==0){
        if(!this.ProductInfo.IsIncludedSubmitOrderInfo){
          this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
            v.RouTuanPrice = this.routuanPrice
            return v
          })
        }else{
          this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
            v = v.map(x=>{
              x.RouTuanPrice = this.routuanPrice
              return x
            })
            return v
          })
        }
      }else{
        this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map((v,index)=>{
          v.RouTuanPrice = this.routuanPrice
          return v
        })
      }
    }
    private getskuName(){
      this.skuName = []
      for(let i = 0;i<this.specificationsNum;i++){
        let key = 'SpecTitle'+(i==0?'':i+1)
        if(this.ProductInfo[key]){
          this.skuName.push({
            sku_name: this.ProductInfo[key],
            sku_info: [],
            key:Math.random(),
            Sort:i+1,
          })
        }
      }
      this.ProductInfo.ProductSpecList.map(item=>{
        for(let i = 0;i<this.specificationsNum;i++){
          let key = 'SpecValue'+(i==0?'':i+1)
          if(item[key] && this.skuName[i]){
            var have = null;
            this.skuName[i].sku_info.map((obj: any, index: number) => {
              if (obj.sku_value === item[key]) {
                have = obj;
              }
            })
            if (!have) {
              let data = {
                sku_value: item[key],
              }
              this.skuName[i].sku_info.push(data)
            }
          }
        }
      })
      // console.log(this.ProductInfo,this.skuName)
    }
    private getShoplist(){
      if(this.ProductInfo.ProductType==0&&this.ProductInfo.IsIncludedSubmitOrderInfo){
        let list = this.getshardlist(this.ProductInfo.ProductSpecList)
        this.totalSku = list.map(v=>{
          return {
            RouTuanPrice:''
          }
        })
        this.ProductInfo.ProductSpecList = list
      }else if(this.ProductInfo.ProductType==1){
        this.ProductInfo.ProductMixList.sort((a,b)=>{
          return b.ProductId - a.ProductId
        })
        let list = this.getassemblylist(this.ProductInfo.ProductMixList)
        this.totalSku = list.map(v=>{
          return {
            RouTuanPrice:''
          }
        })
        // console.log(list)
        this.ProductInfo.ProductMixList = list
        this.routuanPrice = this.ProductInfo.ProductSpecList[0].RouTuanPrice
      }
    }
    private getshardlist(list:any){
      let sku = JSON.parse(JSON.stringify(this.skuName))
			let newlist:any = []
			sku[0].sku_info.map((v,i)=>{
				let data:any = []
				list.map(x=>{
					if(x.SpecValue==v.sku_value){
						data.push(x)
					}
				})
				newlist.push(data)
			})
			return newlist
    }
    private getassemblylist(list:any){
      return list.map((v,i)=>{
        v.skuName = []
        for(let i = 0;i<this.specificationsNum;i++){
          let key = 'SpecTitle'+(i==0?'':i+1)
          if(v[key]){
            v.skuName.push({
              sku_name: v[key],
              sku_info: [],
              key:Math.random(),
              Sort:i+1,
            })
          }
        }
        v.ProductSpecList.map(item=>{
          for(let i = 0;i<this.specificationsNum;i++){
            let key = 'SpecValue'+(i==0?'':i+1)
            if(item[key] && v.skuName[i]){
              var have = null;
              v.skuName[i].sku_info.map((obj: any, index: number) => {
                if (obj.sku_value === item[key]) {
                  have = obj;
                }
              })
              if (!have) {
                let data = {
                  sku_value: item[key],
                }
                v.skuName[i].sku_info.push(data)
              }
            }
          }
        })
        return v
      })
    }
    private recover(){
      this.form = {
        Id:'',
        TemplateName:'',
        FreightSettlementType:1,
        DetailList:[],
        UseProductList:[],
      }
    }
    private async getDate(){
      try{
        this.loading = true
        let res = await freightSettlementTemplatefreightSettlementTemplateInfo({
          Id:this.$route.query.Id,
          ProductId:this.$route.query.ProductId,
        })
        if(res.IsSuccess){
          this.form = res.Result
          if(this.form.ProductInfo&&this.form.ProductInfo.ProductId){
            this.ProductInfo = res.Result.ProductInfo
            this.getskuName()
            this.getShoplist()
          }
        }
      }finally{
        this.loading = false
      }
    }
    private delrow(e){
      this.form.DetailList.splice(e,1)
    }
    private selectConfirm(e){
      // console.log(e)
      if(!e.list||!e.list.length){
        this.$message.error('请选择配送区域')
        this.isShowDialog  =true
        return
      }
      if(this.areatype<0){
        this.form.DetailList.push({
          AreaNames:e.list.map(v=>{
            return v.join('-')
          }),
          Id:0,
          FirstCountToNumber:'',
          FirstMoneyToNumber:'',
          ContinueCountToNumber:'',
          ContinueMoneyToNumber:'',
        })
      }else{
        this.form.DetailList[this.areatype].AreaNames = e.list.map(v=>{
          return v.join('-')
        })
      }
    }
    private pushDispensingArea(type,row?:any){
      this.areatype = type
      if(row.AreaNames&&row.AreaNames.length){
        this.selectArea = JSON.parse(JSON.stringify(row.AreaNames.map(x=>{
          return x.split('-')
        })))
      }else{
        this.selectArea = []
      }
      this.disableDate = this.disableDate = JSON.parse(JSON.stringify(this.form.DetailList)).map(v=>{
        return v.AreaNames.map(x=>{
          return x.split('-')
        })
      }).flat().filter(v=>{
        let ishave = this.selectArea.some(m=>{
          let v0 = v[0]&&m[0]==v[0]
          let v1 = true
          if(v[1]){
            v1 = m[1]&&m[1]==v[1]
          }
          return v0&&v1
        })
        return !ishave
      })
      this.isShowDialog = true
    }
    private save(){
      if(!this.test()) return
      this.orderSaveTips = true
    }
    private test(){
      let form = JSON.parse(JSON.stringify(this.form))
      // console.log(form)
      if(!form.TemplateName){
        this.$message.error('请输入模板名称')
        return false
      }
      if(!form.DetailList||!form.DetailList.length){
        this.$message.error('请设置区域运费规则')
        return false
      }
      let two = /^\d+(\.\d{1,2})?$/
      for(let item of form.DetailList){
        if(form.FreightSettlementType==1){
          if(!item.FirstCountToNumber&&String(item.FirstCountToNumber)!=='0'
          ||!item.ContinueMoneyToNumber&&String(item.ContinueMoneyToNumber)!=='0'
          ||!item.ContinueCountToNumber&&String(item.ContinueCountToNumber)!=='0'
          ||!item.FirstMoneyToNumber&&String(item.FirstMoneyToNumber)!=='0'){
            this.$message.error('物流价格或件数不能为空')
            return false
          }
          if(
            item.ContinueMoneyToNumber<0||item.ContinueMoneyToNumber>1000000||!two.test(item.ContinueMoneyToNumber)||
            item.FirstMoneyToNumber<0||item.FirstMoneyToNumber>1000000||!two.test(item.FirstMoneyToNumber)
            )
            {
              this.$message.error('运费金额最大支持1000000')
              return false
            }
        }else{
          if(!item.FirstMoneyToNumber&&String(item.FirstMoneyToNumber)!=='0'){
            this.$message.error('请完善区域运费规则')
            return false
          }
          if(item.FirstMoneyToNumber<0||item.FirstMoneyToNumber>1000000||!two.test(item.FirstMoneyToNumber)){
            this.$message.error('运费金额最大支持1000000')
            return false
          }
        }
      }

      return true
    }
    private async confirmsave(){
      try{
        this.loading = true
        let res = await freightSettlementTemplatefreightSettlementTemplateSave({
          ...this.form,
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.cancel()
        }
      }finally{
        this.loading = false
      }
    }
    private cancel(){
      this.$router.go(-1)
    }
  }
